"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineComponent = void 0;
var vue_1 = require("vue");
Object.defineProperty(exports, "defineComponent", { enumerable: true, get: function () { return vue_1.defineComponent; } });
